<div class="flex flex-col flex-auto min-w-0">
  <div
    class="flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between p-6 sm:py-8 sm:px-10 border-b bg-card dark:bg-transparent"
  >
    <div class="flex-1 min-w-0">
      <div></div>
      <div class="mt-2">
        <h2
          class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate"
        >
          Staff Registration Form
        </h2>
      </div>
    </div>
  </div>
  <div class="flex-auto p-6 sm:p-10">
    <div>
      <form
        class="p-4 bg-card shadow rounded overflow-hidden"
        [formGroup]="staffForm"
        #staffFormNgForm="ngForm"
        (ngSubmit)="onFormSubmit()"
      >
        <div class="flex flex-col gt-xs:flex-row">
          <h2
            class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 w-full border-b pb-2"
          >
            Staff Authentication
          </h2>
          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Email</mat-label>
              <input
                [placeholder]="'Email'"
                id="email"
                matInput
                [formControlName]="'email'"
                type="email"
                required
              />
              <mat-error *ngIf="staffForm.get('email').hasError('required')"
                >Please enter email</mat-error
              >
              <mat-error *ngIf="staffForm.get('email').hasError('email')"
                >Please enter a valid email</mat-error
              >
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Password</mat-label>
              <input
                [placeholder]="'password'"
                id="password"
                matInput
                [formControlName]="'password'"
                required
              />
              <mat-error>Please enter password</mat-error>
            </mat-form-field>
          </div>
        </div>

        <hr />

        <div class="flex flex-col gt-xs:flex-row">
          <h2
            class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 w-full border-b pb-2"
          >
            Staff Information
          </h2>
          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Staff Name</mat-label>
              <input
                [placeholder]="'Staff Name'"
                id="name"
                matInput
                [formControlName]="'name'"
              />
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Address</mat-label>
              <input
                [placeholder]="'Address'"
                id="address"
                matInput
                [formControlName]="'address'"
              />
            </mat-form-field>
          </div>

          <div class="mainDiv">
            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Phone</mat-label>
              <input
                [placeholder]="'Phone'"
                id="phone"
                matInput
                [formControlName]="'cellPhone'"
                (keypress)="allowOnlyNumbers($event)"
              />
              <mat-error *ngIf="staffForm.get('cellPhone')?.errors?.pattern">
                Please enter a valid phone number
              </mat-error>
            </mat-form-field>

            <mat-form-field class="flex-auto gt-xs:pr-3 items">
              <mat-label>Role</mat-label>
              <mat-select [formControlName]="'role'" required>
                <mat-option *ngFor="let role of roleOptions" [value]="role.key">
                  {{ role.key }}
                </mat-option>
              </mat-select>
              <mat-error>Please select a role</mat-error>
            </mat-form-field>
          </div>
        </div>
        <hr />
        <div class="flex flex-col gt-xs:flex-row">
          <h2
            class="text-lg sm:text-xl font-semibold text-gray-800 mb-4 border-b pb-2"
          >
            Staff Role Permissions
          </h2>
          <table
            mat-table
            [dataSource]="permissionsArray.controls"
            class="mat-elevation-z2 w-full text-sm"
          >
            <ng-container matColumnDef="feature">
              <th mat-header-cell *matHeaderCellDef>Feature</th>
              <td mat-cell *matCellDef="let permission">
                {{ permission.get("feature").value }}
              </td>
            </ng-container>

            <ng-container matColumnDef="view">
              <th mat-header-cell *matHeaderCellDef>View</th>
              <td mat-cell *matCellDef="let permission">
                <mat-checkbox
                  [formControl]="permission.get('view')"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="create">
              <th mat-header-cell *matHeaderCellDef>Add</th>
              <td mat-cell *matCellDef="let permission">
                <mat-checkbox
                  [formControl]="permission.get('create')"
                  [disabled]="permission.get('create').disabled"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef>Edit</th>
              <td mat-cell *matCellDef="let permission">
                <mat-checkbox
                  [formControl]="permission.get('edit')"
                  [disabled]="permission.get('edit').disabled"
                ></mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="permissionColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: permissionColumns"></tr>
          </table>
          <hr />
        </div>

        <div class="text-center mt-8">
          <button
            class="px-8 ml-4 submit-button"
            mat-raised-button
            color="primary"
            [disabled]="staffForm.invalid"
            aria-label="AddAdministrator"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="loaderMain" *ngIf="pageLoader === true">
    <div>
      <img src="assets\TrailFusion\Trail-Fusion-logo.jpg" class="LoaderImage" />
      <p class="loaderText">{{ pageLoaderText }}</p>
    </div>
  </div>
</div>
